import { Typography } from '@mui/material';
import React from 'react';
export function renderApiErrors(error) {
    return (React.createElement(Typography, { component: 'div' }, error.errors ? error.errors.map((message, i) => React.createElement("div", { key: i }, message.text)) : error.message));
}
export function renderApiErrorsArray(errors) {
    return (React.createElement(Typography, { component: 'div' }, errors.map((message, i) => (React.createElement("div", { key: i }, message.text)))));
}
